// extracted by mini-css-extract-plugin
export default {"modalContent":"new-caption-modal_modalContent__QRRNU","modalInputGroup":"new-caption-modal_modalInputGroup__C1rTM","captionDropzone":"new-caption-modal_captionDropzone__OZn1H"};